(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionTriggers = document.querySelectorAll('.mobile-menu__accordion-trigger');
    
    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const contentId = this.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        
        // Close all other accordions
        accordionTriggers.forEach(t => {
          if (t !== this) {
            t.setAttribute('aria-expanded', 'false');
            const cId = t.getAttribute('aria-controls');
            const c = document.getElementById(cId);
            if (c) c.classList.remove('is-open');
          }
        });
        
        // Toggle current accordion
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-open');
        } else {
          this.setAttribute('aria-expanded', 'true');
          content.classList.add('is-open');
        }
      });
    });

    // Search Drawer Logic
    const searchToggles = document.querySelectorAll('[data-search-toggle]');
    const searchDrawer = document.getElementById('search-drawer');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.querySelector('.search-drawer__input');

    if (searchDrawer) {
      searchToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          searchDrawer.classList.add('is-active');
          searchDrawer.setAttribute('aria-hidden', 'false');
          setTimeout(() => {
            if (searchInput) searchInput.focus();
          }, 300);
        });
      });

      if (searchClose) {
        searchClose.addEventListener('click', function() {
          searchDrawer.classList.remove('is-active');
          searchDrawer.setAttribute('aria-hidden', 'true');
        });
      }

      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchDrawer.classList.contains('is-active')) {
          searchDrawer.classList.remove('is-active');
          searchDrawer.setAttribute('aria-hidden', 'true');
        }
      });
    }

    // Predictive Search Logic
    let searchTimeout = null;
    const searchResultsContainer = document.getElementById('search-live-results');
    const searchPopular = document.getElementById('search-popular');

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = this.value.trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
          if (searchResultsContainer) searchResultsContainer.style.display = 'none';
          return;
        }

        searchTimeout = setTimeout(() => {
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
            .then(response => response.json())
            .then(data => {
              const products = data.resources.results.products;
              if (products.length > 0) {
                let html = '<p class="search-drawer__popular-title">Products:</p><div class="search-drawer__products-grid">';
                products.forEach(product => {
                  html += `
                    <a href="${product.url}" class="search-drawer__product-item">
                      <img src="${product.image}" alt="${product.title}" class="search-drawer__product-img">
                      <div class="search-drawer__product-info">
                        <span class="search-drawer__product-title">${product.title}</span>
                        <span class="search-drawer__product-price">${product.price}</span>
                      </div>
                    </a>
                  `;
                });
                html += '</div>';
                html += `<a href="/search?q=${encodeURIComponent(query)}" class="search-drawer__view-all">View all results for "${query}"</a>`;
                
                if (searchResultsContainer) {
                  searchResultsContainer.innerHTML = html;
                  searchResultsContainer.style.display = 'block';
                }
              } else {
                if (searchResultsContainer) {
                  searchResultsContainer.innerHTML = `<p class="search-drawer__popular-title" style="text-transform:none;letter-spacing:normal;font-family:'Times New Roman', Times, serif;">No products found for "${query}".</p>`;
                  searchResultsContainer.style.display = 'block';
                }
              }
            })
            .catch(err => console.error('Error fetching predictive search', err));
        }, 300);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ── Bulletproof autoplay for iOS / Android / Desktop ── */
    function forceAutoplay(video) {
      /* Guarantee muted (required for autoplay policy) */
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {
          /* Retry on user interaction as ultimate fallback */
          var handler = function() {
            video.play();
            document.removeEventListener('touchstart', handler);
            document.removeEventListener('click', handler);
          };
          document.addEventListener('touchstart', handler, { once: true, passive: true });
          document.addEventListener('click', handler, { once: true });
        });
      }
    }

    document.querySelectorAll('.hero-banner__video').forEach(function(video) {
      /* Mark video as loaded so poster can fade out */
      video.addEventListener('playing', function() {
        video.setAttribute('data-loaded', 'true');
      });

      /* Remove any controls attribute to prevent play button */
      video.removeAttribute('controls');

      /* Attempt autoplay immediately without waiting for events */
      forceAutoplay(video);

      /* Pause/play on visibility to save resources */
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              video.play().catch(function() {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });
        observer.observe(video);
      }
    });

    /* ── Sound toggle ── */
    document.querySelectorAll('.hero-banner__sound-toggle').forEach(function(btn) {
      var section = btn.closest('.hero-banner');
      var video = section ? section.querySelector('.hero-banner__video') : null;
      if (!video) return;

      btn.addEventListener('click', function() {
        if (video.muted) {
          video.muted = false;
          video.volume = 1;
          btn.setAttribute('data-unmuted', 'true');
          btn.setAttribute('aria-label', 'Mute video');
          btn.setAttribute('title', 'Mute video');
        } else {
          video.muted = true;
          btn.removeAttribute('data-unmuted');
          btn.setAttribute('aria-label', 'Unmute video');
          btn.setAttribute('title', 'Unmute video');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    /* ═══════════════════════════════════════════
       Product Gallery Slider
    ═══════════════════════════════════════════ */
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var track   = gallery.querySelector('[data-gallery-track]');
      var slides  = gallery.querySelectorAll('.product-gallery__slide');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var dots    = gallery.querySelectorAll('.product-gallery__dot');
      var thumbs  = gallery.querySelectorAll('.product-gallery__thumb');
      var current = 0;
      var total   = slides.length;
      if (total <= 1) return;

      function goTo(index) {
        if (index < 0) index = 0;
        if (index >= total) index = total - 1;
        if (index === current) return;

        /* Pause any video on current slide */
        var curSlide = slides[current];
        var curVideo = curSlide.querySelector('video');
        if (curVideo) { curVideo.pause(); }

        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        /* Update active states */
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === current); });
        thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === current); });

        /* Auto-play video on new slide */
        var newSlide = slides[current];
        var newVideo = newSlide.querySelector('video');
        if (newVideo) {
          newVideo.muted = true;
          newVideo.play().catch(function() {});
        }

        /* Scroll active thumbnail into view */
        var activeThumb = thumbs[current];
        if (activeThumb) {
          activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(this.getAttribute('data-dot-index'), 10));
        });
      });

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          goTo(parseInt(this.getAttribute('data-thumb-index'), 10));
        });
      });

      /* ── Touch / Swipe support ── */
      var startX = 0, startY = 0, diffX = 0, swiping = false;

      track.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
        track.style.transition = 'none';
      }, { passive: true });

      track.addEventListener('touchmove', function(e) {
        if (!swiping) return;
        diffX = e.touches[0].clientX - startX;
        var diffY = e.touches[0].clientY - startY;
        /* Only horizontal swipe */
        if (Math.abs(diffX) > Math.abs(diffY)) {
          var offset = -(current * 100) + (diffX / track.offsetWidth * 100);
          track.style.transform = 'translateX(' + offset + '%)';
        }
      }, { passive: true });

      track.addEventListener('touchend', function() {
        swiping = false;
        track.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        if (diffX > 50) {
          goTo(current - 1);
        } else if (diffX < -50) {
          goTo(current + 1);
        } else {
          track.style.transform = 'translateX(-' + (current * 100) + '%)';
        }
        diffX = 0;
      });

      /* ── Keyboard navigation ── */
      gallery.setAttribute('tabindex', '0');
      gallery.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { goTo(current - 1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { goTo(current + 1); e.preventDefault(); }
      });
    });

    /* ═══════════════════════════════════════════
       Size Guide & Custom Sizing Modals
    ═══════════════════════════════════════════ */
    var modals = document.querySelectorAll('.size-guide-modal');
    var openSizeGuide = document.getElementById('open-size-guide');
    var openCustomSizing = document.getElementById('open-custom-sizing');
    var sizeGuideModal = document.getElementById('size-guide-modal');
    var customSizingModal = document.getElementById('custom-sizing-modal');
    var closeButtons = document.querySelectorAll('[data-close-modal]');

    function openModal(modal) {
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeAllModals() {
      modals.forEach(function(modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      });
      document.body.style.overflow = '';
    }

    if (openSizeGuide) {
      openSizeGuide.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(sizeGuideModal);
      });
    }

    if (openCustomSizing) {
      openCustomSizing.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(customSizingModal);
      });
    }

    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeAllModals();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAllModals();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
